import { useMemo } from "react";
import { ChargeType, InvoiceModel } from "../../../data/entities";

export const usePaymentModalCalculations = (invoice: InvoiceModel) => {
  return useMemo(() => {
    const chargeItems = invoice.items.filter(item => 
      item.chargeType === ChargeType.Charge && item.price > 0
    );
    
    const holdItems = invoice.items.filter(item => 
      item.chargeType === ChargeType.Hold && item.price > 0
    );
    
    //Items with $0 amount (pay at appointment)
    const noChargeItems = invoice.items.filter(item => item.price === 0);

    const calculateTaxForCategory = (chargeType: ChargeType) => {
      const categoryItems = invoice.items.filter(item => item.chargeType === chargeType);
      return categoryItems.reduce((taxSum, item) => {
        if (item.taxes && item.taxes.length > 0) {
          return taxSum + item.taxes.reduce((sum, itemTax) => sum + (itemTax.value || 0), 0);
        }
        return taxSum;
      }, 0);
    };

    const chargesTax = calculateTaxForCategory(ChargeType.Charge);
    const holdsTax = calculateTaxForCategory(ChargeType.Hold);
    const chargesSubtotal = chargeItems.reduce((sum, item) => sum + item.price, 0);
    const holdsSubtotal = holdItems.reduce((sum, item) => sum + item.price, 0);

    return {
      chargeItems,
      holdItems,
      noChargeItems,
      chargesTax,
      holdsTax,
      chargesSubtotal,
      holdsSubtotal,
      totalCharges: chargesSubtotal + chargesTax,
      totalHolds: holdsSubtotal + holdsTax,
      hasCharges: chargeItems.length > 0,
      hasHolds: holdItems.length > 0,
      hasNoChargeItems: noChargeItems.length > 0,
    };
  }, [invoice]);
};